import type { FormField } from '@cli-types/core-engine/schema.js'
import { addOccurrence } from './add-occurrence.js'
import { collectLocalListNameErrors } from './collect-local-list-name-errors.js'
import { isPersistedFormField } from './is-persisted-form-field.js'

export function collectFormPersistedNames(
  fields: FormField[],
  pathPrefix: string,
  occurrences: Map<string, string[]>,
  errors: string[]
): void {
  for (const field of fields) {
    const fieldPath = `${pathPrefix}.${field.name || field.type}`
    if (field.name && isPersistedFormField(field)) {
      addOccurrence(occurrences, field.name, fieldPath)
    }

    if (field.type === 'group' && field.fields) {
      collectFormPersistedNames(field.fields, fieldPath, occurrences, errors)
    }

    if (field.type === 'list' && field.fields) {
      collectLocalListNameErrors(field.fields, `${fieldPath}.fields`, errors)
    }
  }
}
